(function() {
    const $firstSubmenus = document.querySelectorAll('.submenu-super--1');
    const $secondSubmenus = document.querySelectorAll('.submenu-super--2');

    $firstSubmenus.forEach(submenu => {
        const height = submenu.querySelector('.submenu-super__ul--1').scrollHeight;
        submenu.setAttribute('data-height', height); 
    })

    $secondSubmenus.forEach(submenu => {
        const height = submenu.querySelector('.submenu-super__ul--2').scrollHeight;
        submenu.setAttribute('data-height', height); 
    })

    // === SET CLEARING FUNCTIONS

    const submenusFirstCL = document.querySelectorAll('.submenu-super--1');
    const labelsFirstCL = document.querySelectorAll('.menu-super__a--1');
    const indicatorsFirstCL = document.querySelectorAll('.menu-super__indicator--opener-1');

    const submenusSecondCL = document.querySelectorAll('.submenu-super--2');
    const labelsSecondCL = document.querySelectorAll('.submenu-super__a--2');
    const indicatorsSecondCL = document.querySelectorAll('.menu-super__indicator--opener-2');

    function clearAllHeight() {
        submenusFirstCL.forEach(submenu => {
            submenu.removeAttribute('style');
        })
        submenusSecondCL.forEach(submenu => {
            submenu.removeAttribute('style');
        })
    }

    function clearAllStyles() {
        labelsFirstCL.forEach(label => {
            label.classList.remove('menu-super__a--active');
        })
        indicatorsFirstCL.forEach(indicator => {
            indicator.classList.remove('menu-super__indicator--active');
        })
        labelsSecondCL.forEach(label => {
            label.classList.remove('submenu-super__a--active');
        })
        indicatorsSecondCL.forEach(indicator => {
            indicator.classList.remove('menu-super__indicator--active');
        })
    }

    function clearSecondHeights() {
        submenusSecondCL.forEach(submenu => {
            submenu.removeAttribute('style');
        })
    }

    function clearSecondStyles() {
        indicatorsSecondCL.forEach(indicator => {
            indicator.classList.remove('menu-super__indicator--active');
        })
        labelsSecondCL.forEach(label => {
            label.classList.remove('submenu-super__a--active');
        })
    }

    // === PROCEED WITH MAIN LOGIC

    const $labelsFirst = document.querySelectorAll('span.menu-super__a--1');
    const $indicatorsFirst = document.querySelectorAll('.menu-super__indicator--opener-1');

    function toggleFirstLevelHeights(e) {
        const abox = e.target.closest('.menu-super__abox');
        const currentLabel = abox.querySelector('.menu-super__a');
        const currentIndicator = abox.querySelector('.menu-super__indicator--opener-1');

        const submenu = abox.nextElementSibling;
        const height = submenu.getAttribute('data-height');
        const requiredHeight = parseInt(height);

        if (submenu.getAttribute('style')) {
            clearAllHeight();
            clearAllStyles();
            submenu.removeAttribute('style');
            currentLabel.classList.remove('menu-super__a--active');
            currentIndicator.classList.remove('menu-super__indicator--active');
        } else {
            clearAllHeight();
            clearAllStyles();
            submenu.style.height = requiredHeight + 'px';
            currentLabel.classList.add('menu-super__a--active');
            currentIndicator.classList.add('menu-super__indicator--active');
        }
    }

    $labelsFirst.forEach(label => {
        label.addEventListener('click', toggleFirstLevelHeights);
    })
    $indicatorsFirst.forEach(indicator => {
        indicator.addEventListener('click', toggleFirstLevelHeights);
    })

    // ===

    const labelsSecond = document.querySelectorAll('span.submenu-super__a--2');
    const indicatorsSecond = document.querySelectorAll('.menu-super__indicator--opener-2');

    function toggleSecondLevelHeights (e) {
        const abox = e.target.closest('.menu-super__abox');
        const currentLabel = abox.querySelector('.submenu-super__a--2');
        const currentIndicator = abox.querySelector('.menu-super__indicator--opener-2');

        const submenuSecondLevel = abox.nextElementSibling;

        const submenuFirstLevel = submenuSecondLevel.closest('.submenu-super--1');
        // const submenuFirstLevelHeight = extractNumber(submenuFirstLevel.getAttribute('style'));


        const height = submenuSecondLevel.getAttribute('data-height');
        const requiredHeight = parseInt(height);

        if (submenuSecondLevel.getAttribute('style')) {
            clearSecondHeights();
            clearSecondStyles();
            submenuSecondLevel.removeAttribute('style');
            currentLabel.classList.remove('submenu-super__a--active');
            currentIndicator.classList.remove('menu-super__indicator--active');

            submenuFirstLevel.style.height = parseInt(submenuFirstLevel.getAttribute('data-height')) + 'px';

        } else {
            clearSecondHeights();
            clearSecondStyles();
            submenuSecondLevel.style.height = requiredHeight + 'px';
            currentLabel.classList.add('submenu-super__a--active');
            currentIndicator.classList.add('menu-super__indicator--active');
            
            submenuFirstLevel.style.height = requiredHeight + parseInt(submenuFirstLevel.getAttribute('data-height')) + 'px';

        }
    }

    labelsSecond.forEach(label => {
        label.addEventListener('click', toggleSecondLevelHeights);
    })
    indicatorsSecond.forEach(indicator => {
        indicator.addEventListener('click', toggleSecondLevelHeights);
    })
})();